import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	PUT_SELECTED_FLIGHT_FARE_INFORMATION: type('[Flight Fare Information] selected flight fare information'),
	RESET: type('[Flight Fare Information] reset')
};

export class PutSelectedFlightFareInformationAction implements Action {
	type = ActionTypes.PUT_SELECTED_FLIGHT_FARE_INFORMATION;

	/**
	 *Creates an instance of PutSelectedFlightFareInformationAction.
	 * @param {FareInformation} payload
	 * @memberof PutSelectedFlightFareInformationAction
	 */
	constructor(public payload: any) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	constructor(public payload?) { }
}

export type Actions = PutSelectedFlightFareInformationAction | ResetAction;